import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clickAsLink } from 'helpers/link_helpers';

import { getSelectedPersonIds } from '../../store/selectors/select_list';

const minRecordsForMerge = 2;
const maxRecordsForMerge = 5;

export class MergeButton extends React.Component {
  static propTypes = {
    selectedIds: PropTypes.array.isRequired
  };

  canMerge() {
    const { selectedIds } = this.props;
    return selectedIds.length >= minRecordsForMerge && selectedIds.length <= maxRecordsForMerge;
  }

  handleMergePeople = (e) => {
    const { selectedIds } = this.props;
    const idString = JSON.stringify(selectedIds);
    const uriString = encodeURIComponent(window.location.href);
    const linkUrl = `/contacts/people/merge?person_ids=${idString}&redirect_to=${uriString}`;

    clickAsLink(window, linkUrl, e);
  };

  render() {
    return (
      <button
        className="btn btn-default"
        disabled={!this.canMerge()}
        name="merge-button"
        onClick={this.handleMergePeople}
      >
        Merge Contacts
      </button>
    );
  }
}

const mapStateToProps = state => ({
  selectedIds: getSelectedPersonIds(state)
});

export default connect(mapStateToProps)(MergeButton);
